import React from 'react';
import styles from './WhyChooseUs.module.css';

const features = [
  { icon: '🏠', title: '100% Homemade', gujarati: 'શુદ્ધ ઘરનું' },
  { icon: '✨', title: 'Pure Ingredients', gujarati: 'શુદ્ધ સામગ્રી' },
  { icon: '🍛', title: 'Gujarati Taste', gujarati: 'ગુજરાતી સ્વાદ' },
  { icon: '🌱', title: 'Fresh Everyday', gujarati: 'રોજ તાજું' }
  // { icon: '🚀', title: 'Fast Delivery', gujarati: 'ઝડપી ડિલિવરી' },
  // { icon: '💬', title: 'WhatsApp Order', gujarati: 'વોટ્સએપ ઓર્ડર' }
];

const WhyChooseUs = () => {
  return (
    <section className={styles.whyChooseUs}>
      <div className={styles.container}>
        <h2 className={styles.title}>Why Choose Us?</h2>
        <p className={styles.subtitle}>અમને કેમ પસંદ કરવા?</p>
        
        <div className={styles.grid}>
          {features.map((feature, index) => (
            <div key={index} className={styles.featureCard}>
              <div className={styles.icon}>{feature.icon}</div>
              <h3 className={styles.featureTitle}>{feature.title}</h3>
              <p className={styles.gujaratiTitle}>{feature.gujarati}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
